// Company Detail presentational maps. Monetary helpers + project status come
// from the customer dashboard's format module; this file adds the
// company-type and order-state mappings the detail page needs.

// Customer::Company#company_type enum -> Thai label.
export const COMPANY_TYPE_LABELS = {
  individual: 'บุคคลธรรมดา',
  limited_company: 'บริษัทจำกัด',
  public_company: 'บริษัทมหาชนจำกัด',
  limited_partnership: 'ห้างหุ้นส่วนจำกัด',
  ordinary_partnership: 'ห้างหุ้นส่วนสามัญ',
  other: 'อื่นๆ'
}

// Everything except an individual is a juristic person (นิติบุคคล).
export const companyTypeTag = (companyType) => {
  if (!companyType) return null
  if (companyType === 'individual') {
    return { label: COMPANY_TYPE_LABELS.individual, color: 'default' }
  }
  return { label: 'นิติบุคคล', color: 'geekblue' }
}

// Order AASM states that represent an open quotation (vs. a placed order).
const QUOTATION_STATES = new Set([
  'requesting_quotation',
  'waiting_for_supplier',
  'waiting_customer_confirm'
])

export const isQuotationState = (state) => QUOTATION_STATES.has(state)

export const orderKindLabel = (state) =>
  QUOTATION_STATES.has(state) ? 'ใบเสนอราคา' : 'ออเดอร์'

// Order state -> antd Tag color for the recent orders/quotations table.
export const ORDER_STATE_COLORS = {
  cart: 'default',
  address: 'default',
  requesting_quotation: 'gold',
  waiting_for_supplier: 'gold',
  waiting_customer_confirm: 'processing',
  deposit: 'warning',
  payment: 'success',
  complete: 'success',
  completed: 'success',
  full_transferring_back: 'success',
  cancel: 'error'
}

// Activity kind (order state, or 'create') -> feed dot color.
export const ACTIVITY_DOT_COLORS = {
  create: '#1677ff',
  requesting_quotation: '#d48806',
  waiting_for_supplier: '#d48806',
  waiting_customer_confirm: '#1677ff',
  deposit: '#d48806',
  payment: '#389e0d',
  complete: '#389e0d',
  completed: '#389e0d',
  full_transferring_back: '#389e0d',
  cancel: '#cf1322'
}

export const activityDotColor = (kind) => ACTIVITY_DOT_COLORS[kind] || '#8c8c8c'
